export default __webpack_public_path__ + "static/media/rif.0680e4c9.svg";